import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, removeDocument } from 'store/data/documents';

export function useRemoveDocument(): Operation<(fileId: string) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }] = useActivity(ActionTypes.REMOVE_DOCUMENT);

	function handler(fileId: string) {
		dispatch(removeDocument(fileId));
	}

	return [{ loading, error }, handler];
}
